import React, { FC, useContext } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useNavigate, useParams } from 'react-router-dom';

import ExportSources from 'components/common/ExportSources';
import { EventContext } from 'components/context/EventContext';

import { useModal } from 'vibo-ui/Modal';
import { onError } from 'graphql/helpers';
import { useMe } from 'graphql/hooks/user';
import { downloadPeopleCSV } from './constants';
import { MAX_EXPORT_SONGS_TO_APPLE_MUSIC } from 'services/constants';

import { EXPORT_EVENT_CONTACTS_CSV } from 'graphql/queries/events';

import { EventContactStatus, Modals, MusicExportSource } from 'types/enums';
import {
  TypeExportEventSource,
  ExportEventToSourceModalProps,
} from 'components/modals/ExportEventToSourceModal';

const ExportMusicButtons: FC = () => {
  const { id: eventId = '', sectionId = '' } = useParams<keyof EventPageRouteParams>();

  const navigate = useNavigate();

  const { isCompanyDj, isSingleDj } = useMe();

  const eventContext = useContext(EventContext);

  const { openModal } = useModal();

  const openExportEventToSourceModal = (
    source: TypeExportEventSource,
    maxSongsForExport?: number
  ) =>
    !!eventContext?.event &&
    openModal<ExportEventToSourceModalProps>({
      key: Modals.exportEventToSource,
      props: {
        eventContext,
        eventId,
        sectionId,
        source,
        maxSongsForExport,
      },
    });

  const goToBeatsourcePage = () => navigate(`/event/${eventId}/beatsource`);

  const [exportEventContactsCsv, { loading }] = useLazyQuery(EXPORT_EVENT_CONTACTS_CSV, {
    onCompleted: ({ exportEventContactsCsv }) => {
      downloadPeopleCSV(exportEventContactsCsv);
    },
    onError,
    fetchPolicy: 'no-cache',
    variables: {
      eventId,
      filters: {
        contactStatus: [EventContactStatus.contact, EventContactStatus.joined],
      },
    },
  });

  return (
    <ExportSources
      spotify={{
        onClick: () => openExportEventToSourceModal(MusicExportSource.spotify),
      }}
      appleMusic={{
        onClick: () =>
          openExportEventToSourceModal(
            MusicExportSource.appleMusic,
            MAX_EXPORT_SONGS_TO_APPLE_MUSIC
          ),
      }}
      beatsource={{
        onClick: goToBeatsourcePage,
      }}
      {...(isCompanyDj || isSingleDj
        ? { people: { onClick: exportEventContactsCsv, disabled: loading } }
        : {})}
    />
  );
};

export default ExportMusicButtons;
